import { request } from '@umijs/max';

// 获取品牌列表
export async function getBrandPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/goods/brand/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部品牌
export async function getBrandAll({ filter }: { filter: API.FormValues }) {
  return request('/api/admin/goods/brand/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取品牌详情
export async function getBrandInfo(values: API.FormValues) {
  return request('/api/admin/goods/brand/info', {
    method: 'POST',
    data: values,
  });
}

// 创建品牌
export async function addBrand(values: API.FormValues) {
  return request('/api/admin/goods/brand/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑品牌
export async function editBrand(values: API.FormValues) {
  return request('/api/admin/goods/brand/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除品牌
export async function removeBrand(values: API.FormValues) {
  return request('/api/admin/goods/brand/remove', {
    method: 'POST',
    data: values,
  });
}
